// extracted by mini-css-extract-plugin
export default {"header":"PartsDetails_header__hPMxD","table":"PartsDetails_table__S09bn"};